import React, { useState, useEffect, useCallback } from 'react';
import { FaEllipsisV, FaEdit, FaTrash } from 'react-icons/fa';
import { ThreeDots } from 'react-loader-spinner';
import axiosInstance from "../api/axiosInstance";
import API_ENDPOINTS from "../api/endpoints";
import { toast } from 'react-toastify';
import Modal from '../components/Modal/Modal';
import ConfirmationModal from '../components/Modal/ConfirmationModal';


export default function Locations() {
    const [data, setData] = useState([])
    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [mode, setMode] = useState("create"); // or 'edit'
    const [showModal, setShowModal] = useState(false);
    const [gameTypes , setGameTypes] = useState([]);
    const [locationData, setLocationData] = useState({
        id: "",
        name: "",
        type: "",
        address: "",
        sessions: 0,
    });


    const fetchData = useCallback(async () => {
        setLoading(true);

        try {
            const response = await axiosInstance.get(`${API_ENDPOINTS.LOCATION}`);
            setData(response.data.data);
        } catch (error) {
            toast.error(error.response?.data?.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        const fetchGameTypes = async () => {
            try {
                const response = await axiosInstance.get(`${API_ENDPOINTS.SELECTSCHEMA}`);
                setGameTypes(response.data.locationTypes);
            } catch (error) {
                toast.error(error.response?.data?.message || "Failed to fetch game types");
            }
        };
        // Fetch game types when the component mounts
        fetchGameTypes();
    }, []);


    useEffect(() => {
        fetchData();
    }, [fetchData]);


    const handleOpenCreate = () => {
        setLocationData({ name: "", type: "", address: "", sessions: 0 });
        setMode("create");
        setModalOpen(true);
    };

    const handleOpenEdit = (location) => {
        setLocationData(location);
        setMode("edit");
        setModalOpen(true);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setLocationData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        const formData = {
            name: locationData.name,
            type: locationData.type,
            address: locationData.address,
        }
        setLoading(true);
        try {
            if (mode === "create") {
                await axiosInstance.post(`${API_ENDPOINTS.LOCATION}`, formData);
                toast.success("Location created successfully");
            } else {
                await axiosInstance.patch(`${API_ENDPOINTS.LOCATION}`, {
                    id: locationData.id,
                    name: locationData.name,
                    type: locationData.type,
                    address: locationData.address,
                });
                toast.success("Location updated successfully");
            }
            setModalOpen(false);
            setLoading(false);
            fetchData()

        } catch (error) {
            toast.error(error.response?.data?.error || "Something went wrong");
            setLoading(false);
        }
    };



    const typeColor = {
        Casino: 'bg-blue-900 text-blue-300',
        Online: 'bg-purple-900 text-purple-300',
        League: 'bg-orange-900 text-orange-300',
        Home: 'bg-green-900 text-green-300',
    };

    const handleCancel = () => {
        setModalOpen(false);
        setShowModal(false);
        setLocationData({ name: "", type: "", address: "", sessions: 0 });
    }

    const handleDeleteModal = (loc) => {
        setMode('delete')
        setLocationData(loc);
        setShowModal(true);
    }
    
    const handleDelete = async () => {
        setLoading(true);
        try {
            await axiosInstance.delete(`${API_ENDPOINTS.LOCATION}?id=${locationData.id}`);
            toast.success("Location deleted successfully");
            setShowModal(false);
            fetchData();
        } catch (error) {
            toast.error(error.response?.data?.error || "Something went wrong");
        } finally {
            setLoading(false);
        }
    }


    return (
        <div className="p-6 text-white">
            {loading &&
                <ThreeDots
                    visible={true}
                    height="80"
                    width="80"
                    color="#1976d2"
                    radius="9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClass="dots-loading additional-class"
                />
            }
            <div className="flex md:justify-between flex-col md:flex-row md:items-center mb-6">
                <h1 className="text-3xl font-bold">Locations</h1>
                <button className="bg-secondary mt-5 md:mt-0 justify-center  hover:opacity-75 px-4 py-2 rounded text-white flex items-center gap-2 "
                    onClick={handleOpenCreate}
                >
                    + Add Location
                </button>
            </div>

            <div className="bg-black border border-gray-800 rounded-lg overflow-x-auto text-nowrap ">
                <table className="min-w-full text-sm text-left">
                    <thead className="border-b border-border text-zinc-400 uppercase text-xs">
                        <tr>
                            <th className="px-4 py-4">Location Name</th>
                            <th className="px-4 py-4">Type</th>
                            <th className="px-4 py-4">Address</th>
                            <th className="px-4 py-4">Sessions</th>
                            <th className="px-4 py-4"></th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-800 relative">
                        {data.length > 0 ? (
                            data.map((loc, i) => (
                                <tr key={i} className="hover:bg-zinc-900 transition relative">
                                    <td className="px-4 py-5 font-medium">{loc.name}</td>
                                    <td className="px-4 py-5">
                                        <span
                                            className={`px-3 py-1 rounded-full text-xs font-semibold ${typeColor[loc.type]}`}
                                        >
                                            {loc.type}
                                        </span>
                                    </td>
                                    <td className="px-4 py-5">{loc.address}</td>
                                    <td className="px-4 py-5">{loc.sessions ? loc.sessions : 'NA'}</td>
                                    <td className="px-4 py-5 text-right relative">
                                        <button
                                            onClick={() => setOpenMenuIndex(openMenuIndex === i ? null : i)}
                                            className="text-gray-400 hover:text-white"
                                        >
                                            <FaEllipsisV />
                                        </button>

                                        {openMenuIndex === i && (
                                            <div className="absolute bottom-0 mr-2 right-6 p-1 mt-2 w-32 bg-zinc-800 border border-zinc-700 rounded shadow-lg z-10">
                                                <button
                                                    onClick={() => {
                                                        handleOpenEdit(loc);
                                                        setOpenMenuIndex(null);
                                                    }}
                                                    className="flex items-center gap-2 px-4 py-2 hover:bg-zinc-700 w-full text-left text-sm"
                                                >
                                                    <FaEdit className="text-white" />
                                                    Edit
                                                </button>
                                                <button
                                                    onClick={() => handleDeleteModal(loc)}
                                                    className="flex items-center gap-2 px-4 py-2 hover:bg-zinc-700 w-full text-left text-sm text-red-400"
                                                >
                                                    <FaTrash />
                                                    Delete
                                                </button>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            )))
                            : (
                                <tr>
                                    <td colSpan="5" className="text-center py-6 text-zinc-400 font-semibold">No data avilabel</td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>
            <Modal
                isOpen={modalOpen}
                onClose={handleCancel}
                data={locationData}
                onChange={handleChange}
                onSave={handleSave}
                mode={mode}
                title={mode === "create" ? "Add Location" : "Edit Location"}
                typeOptions={gameTypes}
            />
            <ConfirmationModal
                open={showModal}
                title="Are you sure?"
                message={`This will permanently delete the location "${locationData.name}". This action cannot be undone.`}
                onCancel={handleCancel}
                onConfirm={handleDelete}
            />
        </div>
    );
}
